(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["livechat-facade"] && !Shopify.designMode) return;
  try {
    (() => {
    var facade = document.getElementById('livechat-facade');

    if (!facade) return;

    var loading = false;

    function preconnect() {
      ['https://shopify.livechatinc.com', 'https://cdn.livechatinc.com', 'https://api.livechatinc.com'].forEach(
        function (origin) {
          var link = document.createElement('link');
          link.rel = 'preconnect';
          link.href = origin;
          link.crossOrigin = '';
          document.head.appendChild(link);
        }
      );
    }

    function load(maximize = true) {
      if (loading) return;
      loading = true;

      facade.setAttribute('aria-busy', 'true');

      var script = document.createElement('script');
      script.src = facade.dataset.widgetSrc;
      script.async = true;

      script.onload = function () {
        if (window.LiveChatWidget) {
          window.LiveChatWidget.on('ready', function () {
            facade.remove();
          });

          if (maximize) window.LiveChatWidget.call('maximize');
        } else {
          facade.removeAttribute('aria-busy');
          loading = false;
        }
      };

      script.onerror = function () {
        facade.removeAttribute('aria-busy');
        loading = false;
        console.error('LiveChat failed to load');
      };

      document.head.appendChild(script);
    }

    facade.addEventListener('click', load);

    function scheduleAutoOpen() {
      setTimeout(() => load(false), 4000);
    }

    if (document.readyState === 'complete') {
      scheduleAutoOpen();
    } else {
      window.addEventListener('load', scheduleAutoOpen, { once: true });
    }

    ['pointerdown', 'keydown', 'touchstart'].forEach((type) => {
      document.addEventListener(type, preconnect, { once: true, capture: true, passive: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
